import apiClient from '../index';

export const budgetApi = {
  // Get all budget items
  getBudgets: () => apiClient.get('/budget'),

  // Get budget by ID
  getBudget: (id) => apiClient.get(`/budget/${id}`),

  // Get budget by event
  getBudgetByEvent: (eventId) => apiClient.get(`/budget/event/${eventId}`),

  // Create new budget item
  createBudget: (data) => apiClient.post('/budget', data),

  // Update budget item
  updateBudget: (id, data) => apiClient.put(`/budget/${id}`, data),

  // Delete budget item
  deleteBudget: (id) => apiClient.delete(`/budget/${id}`),

  // Get budget items summary
  getBudgetItems: () => apiClient.get('/budget/budget-items'),

  // Get service categories for budget
  getServiceCategories: () => apiClient.get('/budget/service-categories'),

  // Delete budget item alias
  deleteBudgetItem: (id) => apiClient.delete(`/budget/${id}`),

  // Create budget item alias
  createBudgetItem: (data) => apiClient.post('/budget', data),

  // Update budget item alias 
  updateBudgetItem: (id, data) => apiClient.put(`/budget/${id}`, data),

  // Export budget
  exportBudget: (type) => apiClient.get(`/export/budget/${type}`)
};

export const budgetBidApi = {
  getBids: () => apiClient.get('/budget/bids'),
  getBid: (id) => apiClient.get(`/budget/bids/${id}`),
  getNewBidsView: () => apiClient.get('/budget/bids/new'),
  createBid: (data) => apiClient.post('/budget/bids/new', data),
  awardBid: (id) => apiClient.post(`/budget/bids/award/${id}`, {}),
  rejectBid: (id) => apiClient.post(`/budget/bids/reject/${id}`, {}),
};

export default { budgetApi, budgetBidApi };